import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { useBoolean } from "../../../hooks/common/useBoolean";
import { RemoveIcon } from "../icons/RemoveIcon";

export function RemoveButton(props: ButtonHTMLAttributes<any>) {

    const [openTooltip, open, close,] = useBoolean();

    return (
        <div className="remove_button_area">
            <button className="remove_button" {...props} onMouseEnter={open} onMouseLeave={close}>
                <RemoveIcon />
            </button>
            <div className={classNames("tooltip", { "active": openTooltip })}>
                削除
            </div>
        </div>
    );
}
